/**
 * A tela hospedeira sabe se RECARREGAR depois que o Assistente gravou.
 *
 * Conversa `acbcc000` (alpha-arquitetos, 08/10/2026): a pessoa confirmou pela
 * conversa, a marcação foi gravada, e Verificar folhas e Folha de pontos
 * seguiram mostrando o dado de antes. Remontar o componente da rota (o
 * fallback do R6) não basta para essas duas telas:
 *
 * - Verificar folhas guarda a busca feita no próprio componente: remontada,
 *   volta VAZIA, pedindo para a pessoa refazer o filtro;
 * - Folha de pontos pula a construção quando a store diz que a folha da rota
 *   já foi construída: remontada, mostra a MESMA folha velha.
 *
 * Por isso a tela pode registrar como se revalida, simétrico ao provedor de
 * contexto e ao aplicador de rascunho. Uma tela por vez: quem monta registra,
 * quem desmonta tira o seu. Sem registro, quem hospeda remonta a view.
 */
import { criarLog } from '../../servicos/logDoAssistente'

const log = criarLog('revalidadorDaTela')

export type RevalidadorDaTela = () => void

let revalidador: RevalidadorDaTela | null = null

/** Registra o revalidador da tela montada e devolve a função que o tira. */
export function registrarRevalidadorDaTela (novo: RevalidadorDaTela): () => void {
  revalidador = novo
  log.debug('revalidador da tela registrado')
  return () => {
    if (revalidador === novo) revalidador = null
  }
}

/**
 * Revalida pela tela, se ela registrou como. `false` quer dizer "não há
 * revalidador": quem chamou decide o fallback. Revalidador que quebra também
 * devolve `false` — a tela continua de pé e o fallback ainda pode ajudar.
 */
export function revalidarTelaRegistrada (): boolean {
  if (revalidador === null) return false
  try {
    revalidador()
    return true
  } catch (erro) {
    log.error('o revalidador da tela quebrou', erro)
    return false
  }
}
